var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 13.6083C8.00833 13.6083 6.39167 11.9917 6.39167 10C6.39167 8.00833 8.00833 6.39167 10 6.39167C11.9917 6.39167 13.6083 8.00833 13.6083 10C13.6083 11.9917 11.9917 13.6083 10 13.6083ZM10 7.64167C8.7 7.64167 7.64167 8.7 7.64167 10C7.64167 11.3 8.7 12.3583 10 12.3583C11.3 12.3583 12.3583 11.3 12.3583 10C12.3583 8.7 11.3 7.64167 10 7.64167Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 17.5167C6.86667 17.5167 3.90833 15.6833 1.875 12.5C0.991666 11.125 0.991666 8.88333 1.875 7.5C3.91667 4.31667 6.875 2.48333 10 2.48333C13.125 2.48333 16.0833 4.31667 18.1167 7.5C19 8.875 19 11.1167 18.1167 12.5C16.0833 15.6833 13.125 17.5167 10 17.5167ZM10 3.73333C7.30833 3.73333 4.73333 5.35 2.93333 8.175C2.30833 9.15 2.30833 10.85 2.93333 11.825C4.73333 14.65 7.30833 16.2667 10 16.2667C12.6917 16.2667 15.2667 14.65 17.0667 11.825C17.6917 10.85 17.6917 9.15 17.0667 8.175C15.2667 5.35 12.6917 3.73333 10 3.73333Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5221d4c927d781f90eecb26a36da5eb2.svg";
export { ForwardRef as ReactComponent };